import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { MbHomepageFacetsAdapter } from './mb-homepage-facets.adapter'
import { Facet } from '@spartacus/core'

@Injectable({
  providedIn: 'root',
})
export class MbHomepageFacetsConnector {
  constructor (protected adapter: MbHomepageFacetsAdapter) {}

  getAll (): Observable<Facet[]> {
    return this.adapter.load()
  }
}
